import { ReactNode } from "react";

import { IconComponent } from "types/Icon";

import Box from "../Box";
import IconEmphasized from "../IconEmphasized";
import { IconEmphasizedColor } from "../IconEmphasized/types";
import ActionCardWrapper from "./Wrapper";
import ActionCardDescription from "./Description";
import ActionCardTitle from "./Title";
import ActionCardContent from "./Content";
import ActionCardTextWrapper from "./TextWrapper";

type ActionCardProps = {
  title: string;
  titleSuffix?: ReactNode;
  description?: string | ReactNode;
  icon: IconComponent;
  actionComponent: ReactNode;
  /** Optional content rendered inside the card, below the description. */
  children?: ReactNode;
  emphasized?: boolean;
  iconColor?: IconEmphasizedColor;
};

const ActionCard = ({
  title,
  titleSuffix,
  icon,
  description,
  actionComponent,
  children,
  emphasized,
  iconColor,
}: ActionCardProps) => {
  return (
    <ActionCardWrapper emphasized={emphasized}>
      <ActionCardContent>
        <Box justify="between" align="center" gap="medium" fullWidth>
          <IconEmphasized color={iconColor} icon={icon} />
          <Box>{actionComponent}</Box>
        </Box>

        <ActionCardTextWrapper>
          <ActionCardTitle suffix={titleSuffix}>{title}</ActionCardTitle>

          {description && <ActionCardDescription>{description}</ActionCardDescription>}
        </ActionCardTextWrapper>

        {children}
      </ActionCardContent>
    </ActionCardWrapper>
  );
};

ActionCard.displayName = "DS.ActionCard";

export default ActionCard;
